import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';

export interface CreateUserAlliedBody {
  id_allied: string;
  email: string;
  role: 'Premium' | 'Standard';
}

export interface IUserAllied {
  _id: string;
  id_allied: string;
  email: string;
  role: 'Premium' | 'Standard';
  recoveryToken?: string;
  refresh_token?: string;
  created_At?: string;
  updated_At?: string;
}

export interface IUserAlliedResponse {
  message: string;
  data: IUserAllied[];
}

@Injectable({
  providedIn: 'root',
})
export class UserAlliedService {
  private urlProd: string = environment.apiRoot;
  private _refresrequired = new Subject<void>();

  constructor(private http: HttpClient) {}

  get Refreshrequired() {
    return this._refresrequired;
  }

  public createUserAllied(body: CreateUserAlliedBody) {
    return this.http
      .post(`${this.urlProd}admin-user-allieds/add-user-allied`, body, {
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this._refresrequired.next();
        }),
      );
  }

  public getUsersByAllied(idAllied: string) {
    return this.http.get<IUserAlliedResponse>(
      `${this.urlProd}admin-user-allieds/allied/${idAllied}`,
      {
        context: checkToken(),
      },
    );
  }
}
